const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'HomeAndConstructionBusiness',
  name: '祐灃室內裝修',
  alternateName: 'Yufeng Interior Design',
  url: siteUrl,
  telephone: '04-2391-9988',
  email: 'service@yufeng-interior.com',
  foundingDate: '2008',
  description:
    '深耕台中太平區逾20年，提供天花板、地板、牆壁、隔間、櫥櫃等全方位專業木作施工服務。20年以上施工經驗，500件以上完工案例。',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '樹孝路274巷9弄21號1樓',
    addressLocality: '太平區',
    addressRegion: '台中市',
    addressCountry: 'TW',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 24.1333,
    longitude: 120.7167,
  },
  areaServed: {
    '@type': 'City',
    name: '台中市',
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: '木作裝修服務',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '天花板工程' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '地板工程' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '牆壁工程' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '隔間工程' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '櫥櫃工程' } },
    ],
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    reviewCount: '500',
    bestRating: '5',
    worstRating: '1',
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '18:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Saturday'],
      opens: '09:00',
      closes: '17:00',
    },
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '祐灃室內裝修',
  url: siteUrl,
  inLanguage: 'zh-TW',
  description: '台中太平區室內裝修・木工裝潢・天花板地板隔間櫥櫃施工',
};

const SchemaOrg = () => (
  <>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
    />
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
    />
  </>
);

export default SchemaOrg;
